module.exports = __webpack_public_path__ + "static/media/img_jerusalen.a4141f0d.jpg";